/* ImportAction.js */

"use strict";

// const _ = require("lodash");
const ImportScreenComponent = require("./ImportScreenComponent");
const ImportSummaryComponent = require("./ImportSummary/ImportSummaryComponent");
const _ = require("lodash");

class ImportAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        NetworkDiscoveryPlan,
        userSession,
        activityMonitor,
        steveIo,
        activeView,
        Credentials
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._NetworkDiscoveryPlan = NetworkDiscoveryPlan;
        this._modalUserFeedback = modalUserFeedback;
        this._steveIo = steveIo;
        this._activeView = activeView;
        this._credentialsEntityDef = Credentials;
        this._activityMonitor = activityMonitor;
        this._activeOrgId = this._userSession.activeOrganization.id;
        this._conceptItemLabelValues = {};
        this.run = this.run.bind(this);
    }

    _isUuid(str) {
        const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
        return regex.exec(str) !== null;
    }

    _isRegExp(str) {
        try {
            new RegExp(str);
            return true;
        } catch (err) {
            return false;
        }
    }

    run() {
        let importScreenComponent = new ImportScreenComponent(
            this._logger,
            this._userSession,
            this._steveIo,
            this._credentialsEntityDef
        );
        let isUploadingReady = false;
        const ActivityMonitor = this._activityMonitor;
        const sessionExpiredTime =
            ActivityMonitor._options.pollingInterval * ActivityMonitor._options.maxInactivityPolls -
            1000;

        /** Checks current loading time and prevents user session times out */
        let startCheckTimer = function () {
            if (isUploadingReady === true) {
                // Loading is done, turn off the checker
                return;
            } else {
                // Extend user session, and load timer again
                ActivityMonitor._resetInactivityPolls();
                setTimeout(startCheckTimer, sessionExpiredTime);
            }
        };

        let zoneSetToDefault = "";

        return this._modalUserFeedback
            .displayCustom(importScreenComponent, {
                dontHide: true,
            })
            .then(async (result) => {
                this._modalUserFeedback.displayLoading({
                    message: "Importing your file... This could take a moment",
                });
                // Let check results in 15 minutes
                setTimeout(startCheckTimer, sessionExpiredTime);

                switch (result.action) {
                    case "bulkImport":
                        let importedData = result.importData;
                        let importedPlans = [];
                        for (let i = 0; i < importedData.length; i++) {
                            let importedDataObject = importedData[i];
                            // let ruleErrors = [];
                            let importedPlan = new this._NetworkDiscoveryPlan(this._activeOrgId),
                                // validateErrors = [],
                                // validateErrorString = "",
                                importedPlanName =
                                    importedDataObject.name && importedDataObject.name.trim();

                            Object.keys(importedDataObject).forEach((prop) => {
                                if (prop === "engineZone") {
                                    let engineZoneId = "";
                                    const engineZoneObj = Object.values(
                                        _.get(this._gameEditor, "_activeView._engineZoneValues", {})
                                    ).find((i) => i.title === importedDataObject["engineZone"]);
                                    if (engineZoneObj) {
                                        engineZoneId = engineZoneObj.name;
                                    }
                                    importedPlan["engineZoneId"] = engineZoneId;
                                } else {
                                    importedPlan[prop] = importedDataObject[prop];
                                }
                            });

                            if (
                                _.isEmpty(importedPlan.getEngineZoneId()) &&
                                _.get(this._gameEditor, "_activeView._defaultZoneId", false)
                            ) {
                                if (importedPlan.getEngineZoneId() === "") {
                                    zoneSetToDefault =
                                        "Engine zone does not exist. Plan updated to use the default zone.";
                                }
                                importedPlan.setEngineZoneId(
                                    _.get(this._gameEditor, "_activeView._defaultZoneId", undefined)
                                );
                            }

                            importedPlans.push(
                                (() => {
                                    return importedPlan
                                        .create()
                                        .then((data) => Promise.resolve(data))
                                        .catch((err) =>
                                            Promise.reject({
                                                name: importedPlanName,
                                                err,
                                            })
                                        );
                                })()
                            );
                        }

                        return Promise.allSettled(importedPlans);
                }
            })
            .then((resultPlans) => {
                // console.log(resultPlans);
                isUploadingReady = true;
                const results = {
                    summary: {},
                    successMessages: [],
                    errorMessages: [],
                };
                results.summary = {
                    targetCount: resultPlans.length,
                    successCount: 0,
                    failureCount: 0,
                    planCreateCount: 0,
                };
                let successMessage = "";
                let errorMessage = "";
                resultPlans.forEach((resultPlan, idx) => {
                    if (resultPlan.status === "fulfilled") {
                        results.summary.successCount++;
                        let isLastItem = resultPlans.length + 1 === idx;
                        const msg = "Plan - " + resultPlan.value.name + ", imported successfully";
                        successMessage += msg + (isLastItem ? "" : "\r\n");
                        results.successMessages.push(msg);
                    } else {
                        results.summary.failureCount++;
                        errorMessage += `${resultPlan.reason.err.errorMsg}\r\n`;
                        results.errorMessages.push(
                            `Plan: ${resultPlan.reason.name} Error: ${resultPlan.reason.err.errorMsg}\r\n`
                        );
                        let eMsg = this.generateErrorMsg(resultPlan.reason.err) || "";
                        results.errorMessages = results.errorMessages.concat(eMsg);
                    }
                });
                results.successMessage = successMessage;
                results.errorMessage = errorMessage;
                results.summary.planCreateCount = results.summary.successCount;
                results.zoneSetToDefault = zoneSetToDefault;
                successMessage += errorMessage;

                return this._modalUserFeedback.displayCustom(
                    new ImportSummaryComponent(results, this._logger)
                );
            })
            .catch((err) => {
                isUploadingReady = true;
                if (err.userRejected) {
                    this._logger.warn({error: err}, "ImportAction.run() - User Canceled.");
                    return this._modalUserFeedback.hideDisplayed();
                } else if (err.name === "ErrorInInput") {
                    return this._modalUserFeedback.displayError(err).catch(() => {
                        return Promise.resolve();
                    });
                } else {
                    this._logger.warn({error: err}, "ImportAction.run() - Error");
                    return this._modalUserFeedback.displayError(err).catch(() => {
                        return Promise.resolve();
                    });
                }
            });
    }

    generateErrorMsg(reason) {
        if (reason.errorCode !== "InvalidNetworkDiscovery") {
            return;
        }
        let msg = [];
        reason.validationErrors.forEach((err) => {
            if (typeof err === "string") {
                msg.push(err + "\r\n");
            }
        });
        return msg;
    }
}

module.exports = ImportAction;

ImportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.NetworkDiscoveryPlan",
    "$teve.userSession",
    "$teve.activityMonitor",
    "$teve.io",
    "gameEditor.activeView",
    "$teve.entities.Credentials",
];

ImportAction.$displayDetails = {
    type: "Action",
    name: "ImportAction",
    icon: "configdrift.import_devices",
    shown: true,
    title: "Import Discovery Plan",
    order: 5,
};
